import React from "react";

const Series = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM2 1.33333C1.63181 1.33333 1.33333 1.63181 1.33333 2V7.33333H7.33333V1.33333H2ZM8.66667 1.33333V7.33333H14.6667V2C14.6667 1.63181 14.3682 1.33333 14 1.33333H8.66667ZM14.6667 8.66667H8.66667V14.6667H14C14.3682 14.6667 14.6667 14.3682 14.6667 14V8.66667ZM7.33333 14.6667V8.66667H1.33333V14C1.33333 14.3682 1.63181 14.6667 2 14.6667H7.33333Z"
        fill={color}
      />
    </svg>
  );
};

export default Series;
